/**
 * 店舗階層関連のQuery Hooks（FKV3-12590）
 */

import { useQuery } from '@tanstack/react-query';
import { useAuthHeader } from '@/hooks/useAuth';
import { getSellerHierarchies } from '@/lib/api/seller-hierarchy';
import { sellerHierarchyKeys } from '../keys';
import { CACHE_TIME } from '../client';

/**
 * 店舗階層一覧を取得するQuery Hook
 * @param accountCode アカウントコード
 */
export function useSellerHierarchies(accountCode: string) {
  const { getAuthHeader, isLoading: authHeaderLoading, isAuthorized } = useAuthHeader();

  return useQuery({
    queryKey: sellerHierarchyKeys.list(accountCode),
    queryFn: async () => {
      const authHeaders = getAuthHeader();
      return getSellerHierarchies(accountCode, authHeaders);
    },
    enabled: !authHeaderLoading && isAuthorized && !!accountCode,
    staleTime: CACHE_TIME.ACCOUNTS_LIST,
  });
}
